// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RQl0qCZz7wYeXqZ6A_mX{flex-direction:column;gap:15px;display:flex}.S6upFI7EAS8AF9Z_5B3h{padding:16px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `RQl0qCZz7wYeXqZ6A_mX`,
	"titledRow": `S6upFI7EAS8AF9Z_5B3h`
};
export default ___CSS_LOADER_EXPORT___;
